module.exports = __webpack_public_path__ + "img/language.fe6f733c.png";